import { Box } from "@material-ui/core";
import React, { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import DeleteModal from "../../Components/Dialogs/DeleteModal";
import ListingLayout from "../../Components/UI/ListingLayout";
import Pagination from "../../Components/UI/Pagination";
import SkeletonLoader from "../../Components/UI/SkeletonLoader";
import { deleteWebsite, fetchWebsite } from "../../Stores/Website/actions";
import { commonStyle } from "../../commonStyle";
import { useStyles } from "./style";
import WebsiteCard from "../../Components/Cards/WebsiteCard";

const Website = () => {
  const classes = useStyles();
  const commonClasses = commonStyle();

  const history = useHistory();
  const dispatch = useDispatch();

  const { id } = useParams();
  const userInfo = useSelector((state) => state.AuthReducer.user);
  const currentUserRole = useSelector((state) => state.AuthReducer.user.role);
  const currentUserItem = currentUserRole?.access_permissions?.find(
    (item) => item.item_name === "FAQS",
  );
  const [currentDelete, setCurrentDelete] = useState({
    open: false,
  });
  const { isFetchingWebsite, Websites, isDeleting } = useSelector(
    (state) => state.WebsiteReducer,
  );
  let loading = isFetchingWebsite || isDeleting;

  useEffect(() => {
    if (userInfo?.id) {
      dispatch(fetchWebsite({ page: 1, limit: 10, admin_id: userInfo?.id }));
    }
  }, [userInfo]);

  return (
    <>
      <ListingLayout
        title="Website"
        redirect="/d/website/add"
        item="ENQUIRIES"
        hideAdd={true}
      >
        <Box className={classes.tableContainer}>
          {loading ? (
            <Box className={commonClasses.flexBox}>
              {[1, 2, 3, 4, 5].map((item, i) => (
                <Box key={i} className={commonClasses.flexItemSM}>
                  <SkeletonLoader height={140} type="text" />
                </Box>
              ))}
            </Box>
          ) : (
            <>
              <Box className={commonClasses.flexBox}>
                {Websites?.data?.length > 0 ? (
                  Websites?.data?.map((website, i) => (
                    <Box key={i} className={commonClasses.flexItemSM}>
                      <WebsiteCard
                        data={website}
                        setCurrentDelete={setCurrentDelete}
                        history={history}
                        id={website?.id}
                      />
                    </Box>
                  ))
                ) : (
                  <h3>No website(s) found!</h3>
                )}
              </Box>
            </>
          )}
          <Pagination
            isLoading={loading}
            count={Websites?.last_page ?? 1}
            page={Websites?.current_page ?? 1}
            onPager={(page) =>
              dispatch(fetchWebsite({ page, limit: 9, company_id: id }))
            }
          />
        </Box>
      </ListingLayout>

      <Suspense fallback={<></>}>
        <DeleteModal
          deleteMethod={() => {
            setCurrentDelete({ open: false });
            dispatch(
              deleteWebsite({
                id: currentDelete.id,
                company_id: currentDelete.company_id,
              }),
            );
          }}
          open={currentDelete.open}
          onClose={() => setCurrentDelete({ open: false })}
          details={currentDelete}
          isLoading={false}
        />
      </Suspense>
    </>
  );
};

export default Website;
